import { render, staticRenderFns } from "./AdminChatView.vue?vue&type=template&id=7fd0a6c1&"
import script from "./AdminChatView.vue?vue&type=script&lang=js&"
export * from "./AdminChatView.vue?vue&type=script&lang=js&"
import style0 from "./AdminChatView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports